/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiStudentByExternalIdExternalIdOnlinePost$Params {
  external_id: string;
}

export function apiStudentByExternalIdExternalIdOnlinePost(http: HttpClient, rootUrl: string, params: ApiStudentByExternalIdExternalIdOnlinePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiStudentByExternalIdExternalIdOnlinePost.PATH, 'post');
  if (params) {
    rb.path('external_id', params.external_id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiStudentByExternalIdExternalIdOnlinePost.PATH = '/api/student/by-external-id/{external_id}/online';
